<template>
  <div></div>
</template>

<script>
export default {
  name: "EditorTabs",
  mounted() {
    this.$emit('mounted')
  }
}
</script>

<style scoped>

</style>